function removeAccents(str: string) {
    return str && str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export default removeAccents;